module.exports = __webpack_public_path__ + "img/orientation_change.247d2968.gif";